import {createUserPreferencesManager} from '@modifi/utilities'

export const userPreferences = createUserPreferencesManager<Record<string, string>>()
